import type { IconData } from '@stacksjs/iconify-core'

export const script2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\"><path stroke-linejoin=\"round\" d=\"M7 36.353c.37 6.165-2.5 7.412-4 7.412C3 43.765 9.5 45 19 45c4.485 0 8.301-.275 11.08-.566c2.867-.3 4.93-2.755 4.85-5.636c-.239-8.603-1.026-15.988-1.388-25.798c-.112-3.06 0-9 4.458-10H12C8.686 3 6.005 5.682 6.05 8.995c.087 6.336.32 16.847.95 27.358\"/><path stroke-linejoin=\"round\" d=\"M38 3h1c3 0 6 2.195 6 6.098v.648c0 1.347-.904 2.502-2.237 2.69c-1.823.256-4.822.54-9.221.563\"/><path d=\"M17 13h10m-14 7h14m-13.5 7h14M14 34h14\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default script2
